import { render } from "./KisilerView.vue?vue&type=template&id=26ea1df0"
import script from "./KisilerView.vue?vue&type=script&lang=js"
export * from "./KisilerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__